export const hasEntries = (entryArray) =>
  entryArray && Boolean(Number(entryArray.length));

export const getEntriesCount = (entryArray) =>
  entryArray ? Number(entryArray.length) : 0;
